import React, { useEffect, useState } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import FormDialog from '../../../components/ui/FormDialog';
import { notify, getErrorMessage } from '../../../components/feedback/notify';
import { LimitValue } from '../../../utils/LimitValue';

export default function EditarDesconto(props) {
    const token = localStorage.getItem('token');

    const [discountCode, setDiscountCode] = useState('');
    const [valorDesconto, setValorDesconto] = useState('');
    const [duracaoMeses, setDuracaoMeses] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!props.idDesconto) return;
        const getDescontoById = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/getDescontoById/${props.idDesconto}`, {
                    headers: {
                        Authorization: token
                    }
                });
                setDiscountCode(response?.data?.desconto?.discountCode ?? '');
                setValorDesconto(response?.data?.desconto?.valorDesconto ?? '');
                setDuracaoMeses(response?.data?.desconto?.duracaoMeses ?? '');
            } catch (error) {
                console.error("Erro ao buscar desconto:", error);
                notify.error('Não foi possível carregar os dados do desconto.');
            }
        }
        getDescontoById();
    }, [props.idDesconto, token]);


    const handleClose = () => {
        props.setEditarDesconto(false);
    };

    const handleSubmit = async () => {
        if (discountCode === '' || valorDesconto === '' || duracaoMeses === '') {
            notify.warning('Por favor, preencha todos os campos.');
            return;
        }
        try {
            setLoading(true);
            await axios.put(`${process.env.REACT_APP_API_URL}/atualizarDesconto/${props.idDesconto}`, {
                discountCode,
                valorDesconto,
                duracaoMeses
            }, {
                headers: {
                    Authorization: token
                }
            });
            notify.success('Desconto atualizado com sucesso.');
            handleClose();
        } catch (error) {
            console.error("Erro ao atualizar desconto:", error);
            notify.error(getErrorMessage(error, 'Não foi possível atualizar o desconto.'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <FormDialog
            open={props.editarDesconto}
            onClose={handleClose}
            onSubmit={handleSubmit}
            title="Editar desconto"
            description="Altere as informações do código promocional."
            submitLabel="Salvar alterações"
            loading={loading}
        >
            <TextField
                autoFocus
                required
                label="Código do desconto"
                fullWidth
                value={discountCode}
                onChange={(e) => setDiscountCode(e.target.value)}
                size="small"
            />
            <TextField
                required
                label="Valor do desconto"
                placeholder="0 a 100"
                fullWidth
                value={valorDesconto}
                onChange={(e) => setValorDesconto(LimitValue(e.target.value))}
                size="small"
                slotProps={{ input: { endAdornment: <InputAdornment position="end">%</InputAdornment> } }}
            />
            <TextField
                required
                label="Duração do desconto"
                placeholder="Quantidade de meses"
                fullWidth
                value={duracaoMeses}
                onChange={(e) => setDuracaoMeses(LimitValue(e.target.value))}
                size="small"
                slotProps={{ input: { endAdornment: <InputAdornment position="end">meses</InputAdornment> } }}
            />
        </FormDialog>
    );
}
